import styled from "styled-components";
import { Row, Col, Typography } from "antd";
import colors from "constants/colors";

const { Text } = Typography;

export const StyledRow = styled(Row)`
  width: 100%;
  background-color: var(--neutral);
  padding: 2%;
`;

export const StyledCol = styled(Col)`
  padding-left: 3%;
`;

export const StyledList = styled.ul`
  list-style-type: none;
`;

export const StyledItem = styled.li`
  font-size: 1.3em;
  ::before {
    content: "\\25FC";
    color: ${colors.primary};
    font-weight: bolder;
    font-size: 1em;
    display: inline-block;
    width: 1.5em;
    margin-left: -1.5em;
    position: relative;
    top: 0.05em;
  }
`;

export const StyledText = styled(Text)`
  font-size: 0.75em;
`;

export const StyledName = styled(Text)`
  font-size: 1.15em;
`;

export const StyledImg = styled.img`
  height: 150px;
  width: 150px;
  object-fit: cover;
  border-radius: var(--border-radius);
`;
